import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import DE_TRANSLATION from './translations/de.json'
import EN_TRANSLATION from './translations/en.json'
import ES_TRANSLATION from './translations/es.json'
import FR_TRANSLATION from './translations/fr.json'
import IT_TRANSLATION from './translations/it.json'
import PT_TRANSLATION from './translations/pt.json'
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'de', 'es', 'it', 'pt'],
    resources: {
      de: { translation: DE_TRANSLATION },
      en: { translation: EN_TRANSLATION },
      es: { translation: ES_TRANSLATION },
      fr: { translation: FR_TRANSLATION },
      it: { translation: IT_TRANSLATION },
      pt: { translation: PT_TRANSLATION },
    }
  });

export default i18n;